import { useMemo, useRef } from "react";
import { useAuthToken } from "./useAuthToken";

/**
 * Provides a method for receiving the current authentication token.
 * @returns A function allowing you to query the current authentication token.
 */
export function useGetAuthToken(): () => (string | null) {
  const [authToken] = useAuthToken();
  const currentAuthTokenRef = useRef<string |null>(authToken);
  currentAuthTokenRef.current = authToken;

  return useMemo(() => {
    return () => currentAuthTokenRef.current;
  }, []);
}
